import clsx from "clsx";
import React from "react";
import { DataTableDataType, FormatterType } from "../../../../types";
import TextFormatter from "./TextFormatter";

const PullToTopFormatter = <T extends DataTableDataType>(props: FormatterType<T>) => {
  const { className, ...rest } = props;
  return <TextFormatter {...rest} className={clsx(className, "align-items-start", "mt-3")} alignCenter={false} />;
};

export default PullToTopFormatter;
